import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';
import { FaPen, FaTrash } from 'react-icons/fa';
import {Rest} from "../../Helpers/Rest" 
import {check_roles} from "../../Helpers/Roles" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
var moment = require('moment'); // require
export default class List extends Component {
  state = {}

  componentDidMount = () => {
    this.load()
  };

  load = () => {
    var rest = new Rest(this)
    rest.request("posts", "GET", {}, (res)=>{ 
      this.setState({
        data: res
      })
    })
  }

  delete = (id) => {
    var rest = new Rest(this)
    rest.request("posts", "DELETE", {id:id}, (res)=>{
      this.load()
    })
  }
  
  render() {
    console.log(this.state)
    return (
      <Container>
          <Row className="mt-3 mb-3">
            <Col>
                <h4>All posts of your company</h4>
            </Col>
          </Row>

          {
            this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
          }
          <Row>
              <Col>
                  <a className="btn btn-outline-primary m-1" href="/posts/create">Add post</a>
                  <Table>
                      <thead>
                          <tr>
                              <th>ID</th>
                              <th>Publish date</th>
                              <th>Category</th>
                              <th>Title</th>
                          </tr>
                      </thead>
                      <tbody>
                          {
                            this.state.data && this.state.data.length && this.state.data.map(post=>{
                              return (
                                <tr key={post.id}>
                                  <td><a href={"/posts/edit/"+post.id}>{post.id} <FaPen size={13} title="edit" /></a> </td>
                                  <td>{ moment(post.publish_date).format('YYYY-MM-DD HH:mm') }</td>
                                  <td>{post.category}</td>
                                  <td>{post.name}</td> 
                                  <td><div className="text-danger pointer" onClick={()=>this.delete(post.id)}><FaTrash size={13} title="edit"/> delete</div></td>
                                </tr>
                              )
                            })
                          }
                      </tbody>
                  </Table>
              </Col>
          </Row>
          
      </Container>
    );
  }
}
